import { useMemo } from 'react';
import { useQuery, gql } from '@edreamsodigeo/frontend-api-client';
import { useLogFrontendApiError } from '@edreamsodigeo/frontend-core';
const FEATURE_VARIATIONS = gql`
  query featureVariationsWithVersion(
    $aliases: [FeatureVariationRequestWithVersion!]!
  ) @ignore_update {
    featureVariationsWithVersion(aliases: $aliases) {
      evaluable
      index
      name
    }
  }
`;
export const useFeatureVariationsQuery = baseProps => {
  const featuresQueryResult = useQuery(FEATURE_VARIATIONS, {
    variables: baseProps?.featureVariationsInput,
    skip: !baseProps?.featureVariationsInput || baseProps?.featureVariationsInput?.aliases?.length === 0
  });
  useLogFrontendApiError(featuresQueryResult);
  const {
    status,
    data: rawData
  } = featuresQueryResult;
  const data = useMemo(() => {
    if (!rawData) {
      return null;
    }
    return rawData.featureVariationsWithVersion.reduce((acc, {
      name,
      index,
      evaluable
    }) => {
      acc.set(name, {
        index,
        evaluable
      });
      return acc;
    }, new Map());
  }, [rawData]);
  return {
    status,
    data
  };
};